import { CapacitorHttp } from '@capacitor/core';

/** Réponse brute d'un appel HTTP : status + corps déjà typé. */
export interface XimiHttpResponse<T> {
    status: number;
    data: T;
}

/**
 * POST JSON via CapacitorHttp (HTTP natif → pas de préflight CORS). Seul fichier qui
 * touche le plugin HTTP. Ne lève PAS sur 4xx/5xx : on renvoie le status pour que
 * l'appelant gère les cas (ex. 401 résolution user MobileAPI).
 */
export async function postXimiJson<T>(
    url: string,
    body: unknown,
    headers: Record<string, string> = {}
): Promise<XimiHttpResponse<T>> {
    const response = await CapacitorHttp.post({
        url,
        headers: { 'Content-Type': 'application/json', ...headers },
        data: body
    });
    return { status: response.status, data: response.data as T };
}

/** GET JSON via CapacitorHttp. Mêmes garanties que postXimiJson (ne lève pas sur 4xx/5xx). */
export async function getXimiJson<T>(
    url: string,
    headers: Record<string, string> = {}
): Promise<XimiHttpResponse<T>> {
    const response = await CapacitorHttp.get({ url, headers });
    return { status: response.status, data: response.data as T };
}
